import { MutationCache, QueryClient } from '@tanstack/react-query'

/** The `_id` hey-api stamps on every query key for the home-state endpoint. */
const HOME_STATE_QUERY_ID = 'v2GetStartupHomeState'

export const queryClient = new QueryClient({
  // Home is a function of nearly everything the founder can change — their
  // deck, their profile, their campaign choice, their approvals, their wallet.
  // Asking each of the ~30 mutations that move it to remember to invalidate it
  // meant the ones that forgot left Home and the sidebar CTA describing a state
  // the founder had already left, which reads as the app being broken. So the
  // refresh is structural rather than per-call-site: any successful mutation
  // refreshes Home.
  //
  // Cheap enough to be worth it — one batched request, only when something
  // actually changed, and only if Home is mounted or cached. Mutations that
  // must *await* the fresh state before navigating still invalidate explicitly.
  // Runs alongside each mutation's own onSuccess, never instead of it.
  mutationCache: new MutationCache({
    onSuccess: () => {
      void queryClient.invalidateQueries({
        predicate: (query) =>
          (query.queryKey[0] as { _id?: string } | undefined)?._id === HOME_STATE_QUERY_ID,
      })
    },
  }),
  defaultOptions: {
    queries: {
      retry: 1,
    },
    mutations: {
      onError: (error) => {
        const message = error instanceof Error ? error.message : 'Something went wrong'
        console.error('[Mutation Error]', message)
      },
    },
  },
})
